module.exports = __webpack_public_path__ + "assets/img/pop_extra.318b24ac.png";